import type { ComponentPropsWithoutRef } from 'react'

const CheckBoxGroup = ({ className = '', ...props }: ComponentPropsWithoutRef<'ul'>) => <ul className={`flex flex-wrap ${className}`} {...props} />

export default CheckBoxGroup
